/* Для специалистов, форма персональных данных */

let $personalForm = $('.js-page-personal-data-form');
let currentUserPhone = $personalForm.find('.js-sms-phone-field').val();

$personalForm.data('current-phone', currentUserPhone);


export function pagePersonalDataFormPhone(form) {
    form.closest('.js-common-popup').find('.js-common-popup-close').trigger('click');
    form.find('.js-submit').removeClass('_disabled').removeAttr('disabled');
    $personalForm.find('.js-submit').trigger('click');
    $personalForm.data('current-phone', $personalForm.find('.js-sms-phone-field').val());
}
